import {ScrollContext} from '../dropdownVirtualList';

export const computeIsNearBottomOfScrollableList = (scrollContext: ScrollContext) => {
  const {scrollTop, clientHeight, scrollHeight} = scrollContext;

  return scrollTop + clientHeight > scrollHeight - 50;
};
